var map = {
	"./square-sucursal-lagos-de-moreno.jpg": 9950,
	"./square-sucursal-manzanillo.jpg": 2352,
	"./square-sucursal-rio-nilo.jpg": 8708,
	"./square-sucursal-san-mateo.jpg": 20,
	"./square-sucursal-tetlan.jpg": 4047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8904;